<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ slots_title }}
      td.text-center {{ slots_upline_pt }}%
      td.text-center(v-show="isSearch") {{ slots_account_pt }}%
      td.text-center(v-show="isSearch") {{ slots_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ slots_account_min }}%
</template>

<script>
export default {
  props: {
    isSearch: false
  },
  data() {
    return {
      slots_upline_min: 0,
      slots_upline_max: 0,
      slots_upline_pt: 0,
      slots_account_pt: 0,
      slots_upline_remaining: 0,
      slots_account_min: 0
    }
  },
  computed: {
    slots_title: function () {
      return this.$t("ui.slot_games") + " (" + this.slots_upline_min + "%-" + this.slots_upline_max + "%)"
    }
  }
}

</script>